export const firebaseRefPaths = {
    temperature: "Temperature",
    humidity: "Humidity",
    gas: "Gas",
    realAltitude: "Real_Altitude",
    pressure: "Pressure",
    gas: "Gas",
}

export const firebaseRootPath = "watchdog"
